import { useRef, useEffect, useState } from 'react'
import styled from 'styled-components'
import { Button, Row, Col, Form, message } from "./../../../ui/ot"
import { useNavigate, useParams } from 'react-router-dom'
import { useBib } from '../../controllers/BibController'
import { useItem } from '../../controllers/ItemController'
import { ItemForm } from '../../views/BackStage/item_form'
const NewOrEditItem = () => {
    const thisJS = "AddOrEditItem"
    const { biblionumber, itemnumber } = useParams()
    const bIsPostMode = (itemnumber === undefined || itemnumber === "0")
    const bIsPatchMode = !bIsPostMode && biblionumber !== undefined && itemnumber !== undefined
    const navigate = useNavigate()
    const [form] = Form.useForm();
    const formRef = useRef()
    const [modalLoading, setModalLoading] = useState(false)
    const [axiosMode, setAxiosMode] = useState(bIsPostMode ? "post" : (bIsPatchMode ? "patch" : "get"))
    const [allItemOptions, setAllItemOptions] = useState({
        withdrawn_options: [],
        call_number_source_options: [],
        damaged_options: [],
        restricted_options: [],
        notforloan_options: [],
        collection_options: [],
        library_options: [],
        location_options: [],
        shelving_control_number_options: [],
        item_type_options: []
    })
    const onFormFinish = (values) => {
        console.log({
            values
        })
        //console.log(thisJS, "onFormFinish", axiosMode, values)
        if (axiosMode === "get") { return; }
        if (bIsPostMode) {
            postItemData([{ ...values }])
        } else if (bIsPatchMode) {
            patchItemData([{ ...values }])
        }
    }

    //#region Bib Data
    const {
        BibData,
        getBibData
    } = useBib({
        onBefore: ({ axiosMode, values }) => {
            // console.log(thisJS, "BibData", axiosMode, "onBefore", values)
        },
        onFinish: ({ axiosMode, status, values }) => {
            // console.log(thisJS, "BibData", axiosMode, "onFinish", status, values)
        }
    })
    //#endregion
    //#region Item Data
    const {
        ItemData,
        getItem_ApiData,
        postItemData,
        patchItemData
    } = useItem({
        onBefore: ({ axiosMode, values }) => {
            //console.log(thisJS, "ItemData", axiosMode, "onBefore", values)
            const bIsGet = axiosMode === "get"
            if (!bIsGet) { setModalLoading(true) }
        },
        onFinish: ({ axiosMode, status, values }) => {
            //console.log(thisJS, "ItemData", axiosMode, "onFinish", status, values)
            const bIsPost = axiosMode === "post"
            const bIsPatch = axiosMode === "patch"
            if (bIsPost || bIsPatch) {
                const cMode = bIsPost ? "新增" : "修改"
                if (status === "success") {
                    message.success(cMode + "成功")
                } else {
                    message.error(cMode + "失敗")
                }
                setModalLoading(false)
            }
        }
    })

    useEffect(() => {
        if (itemnumber && form) {
            getItem_ApiData({
                itemnumber: itemnumber ?? "0"
            })
                .then((response) => {
                    let datas = response?.data
                    let firstData = datas?.find((ele) => true)
                    let defaultValue = { ...firstData } // {}
                    defaultValue.biblio_id = parseInt(biblionumber)
                    defaultValue.item_id = parseInt(itemnumber ?? "0")
                    setAllItemOptions((pre) => {
                        return {
                            withdrawn_options: defaultValue?.withdrawn_options,
                            call_number_source_options: defaultValue?.call_number_source_options,
                            damaged_options: defaultValue?.damaged_options,
                            restricted_options: defaultValue?.restricted_options,
                            notforloan_options: defaultValue?.notforloan_options,
                            collection_options: defaultValue?.collection_options,
                            library_options: defaultValue?.library_options,
                            location_options: defaultValue?.location_options,
                            shelving_control_number_options: defaultValue?.shelving_control_number_options,
                            item_type_options: defaultValue?.item_type_options,
                        }
                    })

                    /*
                    Object.keys(firstData).forEach((key) => {
                        if (key === "branches") {
                            if (firstData[key] === "") {
                                defaultValue[key] = []
                                defaultValue['branches'] = []
                            }
                            else {
                                let branchesArr = firstData[key].map((val) => {
                                    return {
                                        label: val?.branchname,
                                        value: val?.branchcode,
                                    }
                                })
                                defaultValue['branches'] = branchesArr
                            }
                        }
                        else if (intKeys.includes(key)) {
                            defaultValue[key] = !!firstData[key] || firstData[key] === 0 ? firstData[key] : undefined
                        }
                        else {
                            defaultValue[key] = !!firstData[key] || firstData[key] === 0 ? `${firstData[key]}` : ''
                        }
                    })
                    */
                    //console.log(thisJS, "ItemData", axiosMode, "useEffect", defaultValue)
                    // formRef.current.setValues(defaultValue)
                    form.setFieldsValue({
                        ...defaultValue,
                        itemnumber: defaultValue?.item_id,
                        biblionumber: defaultValue?.biblio_id,
                    })
                })
        }
    }, [itemnumber, form])
    useEffect(() => {
        if (biblionumber) {
            getBibData({
                biblionumber: biblionumber
            })
        }
    }, [biblionumber])
    //#endregion
    return (
        <MainContainer>
            <Row className='mb-5'>
                <Title>
                    館藏書籍：{BibData?.find(_ => true)?.bib_title} 作者：{BibData?.find(_ => true)?.bib_author}(Record #{BibData?.find(_ => true)?.bib_biblionumber})
                </Title>
            </Row>
            <WhiteBox>
                <Row className='mb-5'>
                    <Title>
                        {bIsPatchMode ? "修改館藏" : "新增館藏"}
                    </Title>
                </Row>
                <Row>
                    <Col span={24}>
                        <ItemForm
                            propsForm={form}
                            propsOptions={allItemOptions}
                            onFormFinish={onFormFinish}
                            isPropsOptions={true}
                        />
                    </Col>
                    <Col span={24}>
                        {/* <ItemFormOld
                            biblionumber={biblionumber}
                            itemnumber={itemnumber}
                            ref={formRef}
                            onFormFinish={onFormFinish}
                        /> */}
                        {bIsPatchMode && <>
                            <ButtonGroup classnName='mt-4'>
                                <Button onClick={() => {
                                    // formRef.current.onFormSubmit()
                                    form.submit()
                                }}>儲存變更</Button>
                                <Button onClick={() => navigate(`/library/backstage/additem/${biblionumber}/0`)}>新增項目</Button>
                                <Button variant="outline" onClick={() => navigate(`/library/backstage/BookDetail?bib_biblionumber=${biblionumber}` )} >取消</Button>
                            </ButtonGroup>
                        </>}
                        {bIsPostMode && <>
                            <ButtonGroup classnName='mt-4'>
                                <Button onClick={() => formRef.current.onFormSubmit()}>新增項目</Button>
                                <Button>新增和複製項目</Button>
                                <Button variant="outline" >新增複數項目</Button>
                                <Button variant="outline" >儲存成範本</Button>
                            </ButtonGroup>
                        </>}
                    </Col>
                </Row>
            </WhiteBox>
        </MainContainer>
    )
}

const MainContainer = styled.div`
width: 100%;
display: flex;
-webkit-box-pack: center;
justify-content: space-around;
flex-direction: column;
-webkit-box-align: start;
align-items: start;
padding: 2em;
gap: 0.5em;
-webkit-flex-wrap: wrap;
`

const Title = styled.div`
text-align: left;
width: 100%;
font-size: 1.6em;
font-weight: 600;
`

const WhiteBox = styled.div`
background-color: #fff;
width: 100%;
padding: 1em;
`

const ButtonGroup = styled.div`
width: 100%;
display: flex;
gap: 1em;
align-items: flex-start;
`

export default NewOrEditItem